import React from 'react';
import {Box} from 'views/components';
import {Translate} from 'views/module';

const LoadingMessage = () => {
  return (
    <Box sx={{display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px', color: '#555'}}>
      <Box sx={{display: 'flex', gap: '4px'}}>
        <span className="dot" />
        <span className="dot" />
        <span className="dot" />
      </Box>
      <Translate expression="profile.LoadingMessage.Typing" />

      <style>
        {`
          .dot {
            width: 8px;
            height: 8px;
            background-color: #555;
            border-radius: 50%;
            display: inline-block;
            animation: bounceBlink 1.4s infinite both;
          }
          .dot:nth-child(1) {
            animation-delay: 0s;
          }
          .dot:nth-child(2) {
            animation-delay: 0.2s;
          }
          .dot:nth-child(3) {
            animation-delay: 0.4s;
          }

          @keyframes bounceBlink {
            0%, 80%, 100% {
              opacity: 0.3;
              transform: translateY(0);
            }
            40% {
              opacity: 1;
              transform: translateY(-4px); /* how high it “jumps” */
            }
          }
        `}
      </style>
    </Box>
  );
};

export default LoadingMessage;
